import * as React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { decorativeFontStack } from "../../../../styles/typography/v2";
const Root = styled.ol({
  margin: 0,
  padding: 0,
  display: "flex",
  flexDirection: "column",
  gap: 20,
  listStyleType: "none",
});

const ListItem = styled.li({
  display: "flex",
  gap: 10,
});

const Adornment = styled.div(decorativeFontStack, () => ({
  borderWidth: 3,
  borderStyle: "solid",
  borderRadius: "100%",
  alignItems: "center",
  justifyContent: "center",
  display: "flex",
  fontSize: 30,
  height: 41,
  width: 41,
  aspectRatio: 1,
  flexShrink: 0,
}));

function BigNumberList(props) {
  const { children, style } = props;
  return (
    <Root style={{ color: style.textColor }}>
      {React.Children.map(children, (child, idx) => (
        <ListItem>
          <Adornment
            style={{
              color: style.adornmentTextColor,
              backgroundColor: style.adornmentBackgroundColor,
              borderColor: style.adornmentBorderColor,
            }}
          >
            {idx + 1}
          </Adornment>
          {child}
        </ListItem>
      ))}
    </Root>
  );
}

BigNumberList.propTypes = {
  children: PropTypes.node,
  style: PropTypes.shape({
    textColor: PropTypes.string,
    adornmentTextColor: PropTypes.string,
    adornmentBackgroundColor: PropTypes.string,
    adornmentBorderColor: PropTypes.string,
  }),
};

export default BigNumberList;
